export const utils = {
    roundFloor(number, decimalPlaces) {
      var factor = Math.pow(10, decimalPlaces);
      return Math.floor(number * factor) / factor;
    },

    numberFormat(x) {
      if(!x) x = 0
      return parseFloat(x).toFixed(2).toString().replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  
    mergeArrays(oldArray, newArray, key1, key2) {
      const mergedArray = [...oldArray];
    
      newArray.forEach(newObj => {
        const index = mergedArray.findIndex(obj => obj[key1] === newObj[key1] && obj[key2] === newObj[key2]);
        if (index !== -1) {
          mergedArray[index] = newObj;
        } else {
          mergedArray.push(newObj);
        }
      });
    
      return mergedArray;
    },

    findInArray(farray, keyName, value) {
      return farray.find(obj => obj[keyName] === value);
    },

    mergeArrays(oldArray, newArray, key) {
        const mergedArray = [...oldArray];
      
        newArray.forEach(newObj => {
          const index = mergedArray.findIndex(obj => obj[key] === newObj[key]);
          if (index !== -1) {
            mergedArray[index] = newObj;
          } else {
            mergedArray.push(newObj);
          }
        });
      
        return mergedArray;
      },

      removeAccents(str) {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      },

      filterString(item, filterKey) {
        if(filterKey == '') return true;
        var itemStr = item.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        var filterStr = filterKey.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
		
        if(filterStr[ filterStr.length-1 ] == '*' || filterStr[ filterStr.length-1 ] == '%') {
          return itemStr.indexOf(filterStr.substring(0,filterStr.length-1)) == 0
        }
        else
        if(filterStr[0] == '*' || filterStr[0] == '%') {        
          return itemStr.indexOf(filterStr.substring(1)) == (itemStr.length - filterStr.length + 1)
        }
        else {
          return itemStr.indexOf(filterStr) > -1
        }
      },

    
      dateFormat(date) {
        if(date instanceof Date) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }
        else
          return date;
        
      },
      
      dateTimeFormat(date) {
        if(date instanceof Date) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
        
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
        else
          return date;
        
      },

      // Transforma dd/MM/yyyy HH:mm para DateTime
      // 012345678901234567890123
      // 31-12-2023 00:12:12.000Z
      // 2023-12-31 00:12:12.000Z

      stringToDate(strDate) {
        var [day, month, yearTime] = strDate.split('/');
        var [year, time] = yearTime.split(' ');
        var [hour, minute] = time.split(':');
        // JavaScript's Date object uses zero-based months
        month = month - 1; 
        return new Date(year, month, day, hour, minute);
      },

      /*
      stringToDate(strDate) {
        if(typeof strDate === 'string') {
          var ret = "";
          if(strDate.length >= 10) {
            if(strDate[2]=='-' || strDate[2]=='/') {
              ret = strDate.substring(6,10) + "-" + strDate.substring(3,5) + "-" + strDate.substring(0,2);
            }
            else
            if(strDate[4]=='-' || strDate[4]=='/') {
              ret = strDate.substring(0,10).replace('/','-')
            }
          }
          if(strDate.length >= 16) {
            var time = "00:00:00.000Z";
            var t2 = strDate.substring(11);
            ret += "T" + t2 + time.substring(t2.length);
          }
        }
        return ret;
        
      },
      */

      // Usado no Rastrea - TODO - Rever
      // 012345678901234567890123456789
      // 2023-12-30 12:00:00.888+00:00
      // 30-12-2023 12:00:00.888+00:00
      rastreaDateString(date) {
        if(!date || date === null) return '';

        var str = String(date);
        str = str.replace("/","-").replace("T"," ");

        if(str.length >= 10) {

          var day;
          var month;
          var year;
          var hours = "";

          if(str[4]=='-') {
            year = str.substring(0,4);
            month = str.substring(5,7);
            day = str.substring(8,10);
          }
          else
          if(str[2]=="-") {
            year = str.substring(6,10);
            month = str.substring(3,5);
            day = str.substring(0,2);
          }

          if(str.length >= 16) {
            hours = str.substring(11,19);
          }

          str = day + "/" + month + "/" + year + " " + hours;
        }

        return str;
      },


      addDays(date, days) {
        if(date && days) {
          var result
          if(date instanceof String) {
            result = new Date(date + "T12:00:00Z");
          }
          else {
            result = date
          }
          result.setDate(result.getDate() + days);


          return result;
        }
        return date
      },

    
      /*
       dateAdjusted(originalDate) {
        const adjustedDate = new Date(originalDate);
        const offset = adjustedDate.getTimezoneOffset();
        adjustedDate.setMinutes(adjustedDate.getMinutes() - offset);
        return adjustedDate.toISOString().split('T')[0];
      },

      currentUTC() {
        var now = new Date();
        var utc = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds()));
        return utc.toISOString();
      },
      */

      localWeekdayShort(date) {
        if(date) {
          return this.localWeekday(date).split('-')[0]
        }
        return date
      },

      localWeekday(date) {
        if(date) {
          var utcDate = new Date(date)
          const options = { weekday: 'long' };
          return  utcDate.toLocaleDateString(undefined, options);
        }
        return date
      },

      /*
      * Transforma a data UTC para o formato dd/MM/yyyy HH:mm:ss
      */
      localDateTime(date) {
        if(date) {
          var utcDate = new Date(date)
          return utcDate.toLocaleString("en-GB").replace(',','');
        }        
        return null
      },

       /*
      * Transforma a data UTC para o formato dd/MM HH:mm
      */
       localDateTimeShort(date) {
        if(date) {
          var utcDate = new Date(date)
          var strDate = utcDate.toLocaleString("en-GB").replace(',','') 
          return strDate.substring(0,5) + ' ' + strDate.substring(11,16)
        }        
        return null
      },

      /*
      * Transforma a data UTC para o formato dd/MM/yyyy HH:mm
      */
      localDateShortTime(date) {
        if(date)
          return this.localDateTime(date).substring(0,16)
        return date
      },

      /*
       * Transforma a data UTC para o formato dd/MM/yyyy
       */
      localDate(date) {
        if(date)
          return this.localDateTime(date).substring(0,10)
        return date
      },

      localUtcDate(date) {
        if(date instanceof Date) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${day}-${month}-${year}`;
        }
        else
          return date;
        
      },

       /*
       * Transforma a data UTC para o formato dd/MM/yyyy
       */
       localTime(date) {
        if(date && date.length >= 16) {
          if(date.length >= 19)
            return this.localDateTime(date).substring(11,19)
          else
            return this.localDateTime(date).substring(11);
        }
        return date
      },

       /*
       * Transforma a data UTC para o formato dd/MM/yyyy
       */
       localShortTime(date) {
        if(date && date.length >= 16)
          return this.localDateTime(date).substring(11,16)
        return date;
      },

      /*
      Transforma a data TEXTO para o formato dd/MM/yyyy HH:mm:ss
      */
      dateTimeStringFormat(date) {
          if(date && date.length >= 10) {
            const year = date.substring(0,4);
            const month = date.substring(5,7);
            const day = date.substring(8,10);
            var hours = "";
            if(date.length >= 16) {
              if(date.length >= 19) {
                hours = date.substring(11,19) 
              }
              else {
                hours = date.substring(11,16) 
              }
            }
            return `${day}/${month}/${year} ${hours}`;
          }

        return date;
        
      },

      /*
      Transforma a data TEXTO para o formato dd/MM/yyyy HH:mm
      */
      dateShortTimeStringFormat(date) {
        if(date && date.length >= 10) {
          const year = date.substring(0,4);
          const month = date.substring(5,7);
          const day = date.substring(8,10);
          var hours = "";
          if(date.length >= 16) {
              hours = date.substring(11,16) 
          }
          return `${day}/${month}/${year} ${hours}`;
        }

      return date;
      
    },

      dateToUTC(dateString) {
        // Create a Date object from the string
        const dateObj = new Date(dateString);
      
        // Convert the date to UTC format using toISOString()
        const utcString = dateObj.toISOString();
      
        // Return the UTC string with 'Z' at the end for timezone offset
        return utcString.slice(0, -1) + 'Z';
      },

      /*
      Transforma a data TEXTO "YYYY-MM-DD" para o formato dd/MM/yyyy
      */
      dateStringFormat(date) {
        if(date && date.length >= 10) {
          const year = date.substring(0,4);
          const month = date.substring(5,7);
          const day = date.substring(8,10);
          
          return `${day}/${month}/${year}`;
        }
        return date;
      },

      /**
       * Transforma a data YYYYMMDD para o formato dd/MM/yyyy
       */
      refDateToStringFormat(date) {
        if(date && date.length >= 8) {
          const year = date.substring(0,4);
          const month = date.substring(4,6);
          const day = date.substring(6,8);
          
          return `${day}/${month}/${year}`;
        }
        return date;
      },

      refDateToStringFormat(refDate) {
        refDate = refDate.toString()
        if(refDate && refDate.length == 8) {
          const year = refDate.substring(0,4)
          const month = refDate.substring(4,6)
          const day = refDate.substring(6,8)
          
          return `${day}/${month}/${year}`
        }
        return refDate
      },

      formatCNPJ(cnpj) {
        if(cnpj) {
          cnpj = cnpj.replace(/\D/g, '');
          cnpj = cnpj.padStart(14,'0')
          cnpj = cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
        }
        return cnpj;
      },

      formatCPF(cpf) {
        if(cpf) {
          cpf = cpf.replace(/\D/g, '');
          cpf = cpf.padStart(11,'0')
          cpf = cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
        }
        return cpf;
      },

      numbersOnly(str) {
        return str.replace(/\D/g, '');
      },

      checkEmail(email) {
        if(!email) return false;
        var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
      },

      /*"sun","mon","tue","wed","thu","fri","sat"
       */
      getNextDayOfTheWeek(dayOfWeek, excludeToday = true, refDate = new Date(), hh=0, mm=0) {
        if (dayOfWeek < 0) return;
        /* refDate. .setHours(0,0,0,0); */
        refDate.setDate(refDate.getDate() + +!!excludeToday + 
                        (dayOfWeek + 7 - refDate.getDay() - +!!excludeToday) % 7);
        return refDate;
      },

      nextDayOfWeek(data, indiceDiaSemana) {
        // Converte a data para um objeto Date
        var dataObj = new Date(data);
      
        // Obtém o dia da semana da data
        var diaSemanaAtual = dataObj.getDay();
      
        // Calcula a diferença entre o dia da semana desejado e o dia da semana atual
        var diferencaDias = indiceDiaSemana - diaSemanaAtual;
      
        // Se a diferença for negativa, significa que o dia da semana desejado já passou nesta semana
        if (diferencaDias < 0) {
          // Adiciona 7 dias à diferença para obter a próxima ocorrência do dia da semana
          diferencaDias += 7;
        }
      
        // Adiciona a diferença de dias à data original
        dataObj.setDate(dataObj.getDate() + diferencaDias);
      
        // Retorna a data formatada como YYYY-MM-DD
        return dataObj.toISOString().split('T')[0];
      },

      dateChangeTime(data, hora, minutos) {
        var dataObj = new Date(data);
        dataObj.setHours(hora);
        dataObj.setMinutes(minutos);     
        return dataObj;
      },

      parseHtml(str) {
        const parser = new DOMParser()
        const doc = parser.parseFromString(str, 'text/html')
        return doc.body.textContent
      },

      /*
      * Lembra a Empresa/Inventário selecionados nas telas do módulo de inventário
      * (compartilhado entre InventoryCounter, InventoryFiscal, InventoryIdentification,
      * InventoryLabel, InventoryMonitor, InventorySync, InventorySector), para que a
      * seleção persista entre navegações e recarregamentos de página.
      */
      getInventoryContext(storageName) {
        try {
          var raw = localStorage.getItem((storageName || 'smg') + '_INVENTORY_CONTEXT')
          return raw ? JSON.parse(raw) : null
        }
        catch(e) {
          return null
        }
      },

      setInventoryContext(storageName, companyId, inventoryId) {
        try {
          localStorage.setItem((storageName || 'smg') + '_INVENTORY_CONTEXT', JSON.stringify({ companyId: companyId, inventoryId: inventoryId }))
        }
        catch(e) {
          // localStorage indisponível (modo privado, quota excedida, etc.) - ignora
        }
      }

 }